module.exports = __webpack_public_path__ + "assets/fb-grey.fb3d8b0d.svg";